/**
 * FormRow Component
 */

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import './styles.scss';

const classes = new BEM('form__row');
export default function FormRow({ children }) {
  return (
    <div {...classes() }>{children}</div>
  );
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/forms/FormRow/index.tsx